import React, { useState } from 'react';
import moment from 'moment';
import ThaiDatePicker from '../../Components/ThaiDatePicker';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';

const PageMonthExport = () => {
    const [_StartDate, setStartDate] = useState(moment().startOf('year').toDate());
    const [_EndDate, setEndDate] = useState(moment().toDate());

    const _ExportExcel = async () => {
        Swal.fire('Please wait');
        Swal.showLoading();

        const _reqObj = {
            StartMonth: moment(_StartDate).month() + 1,
            StartYear: moment(_StartDate).year(),
            EndMonth: moment(_EndDate).month() + 1,
            EndYear: moment(_EndDate).year(),
        };

        API({ method: 'post', url: '/Export/Month', params: _reqObj, responseType: 'blob' })
            .then(res => {
                if(res.status !== 200) { Swal.close(); return; }
                let fileName = `Export_${_reqObj.StartMonth}-${_reqObj.StartYear}_to_${_reqObj.EndMonth}-${_reqObj.EndYear}.xlsx`;
                const disposition = res.headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) { 
                        fileName = matches[1].replace(/['"]/g, '');
                        fileName = decodeURIComponent(fileName);
                    }
                }

                const blob = new Blob([res.data], { 
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });

                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(url);
                Swal.close();
            })
            .catch((error) => { 
                console.log(error);
                Swal.close(); 
            });
    };

    const THAI_MONTHS = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'];
    const toThai = (d) => d ? `${THAI_MONTHS[d.getMonth()]} ${d.getFullYear() + 543}` : '';

    return (
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>Export รายงานสรุปร้านค้า</h3>
                            </div>
                            <div className='card-body' style={{ minHeight: '200px' }}>
                                <div className="row mt-2 mb-3 align-items-end">
                                    <div className='col-12 col-lg-2 mt-2'>
                                        <label className='form-label'>เดือน/ปี เริ่มต้น</label>
                                        <ThaiDatePicker
                                            selected={_StartDate}
                                            onChange={(date) => setStartDate(date)}
                                            showMonthYearPicker
                                            maxDate={_EndDate}
                                        />
                                    </div>
                                    <div className='col-12 col-lg-2 mt-2'>
                                        <label className='form-label'>เดือน/ปี สิ้นสุด</label>
                                        <ThaiDatePicker
                                            selected={_EndDate}
                                            onChange={(date) => setEndDate(date)}
                                            showMonthYearPicker
                                            minDate={_StartDate}
                                            maxDate={moment().toDate()}
                                        />
                                    </div>
                                    <div className='col-12 col-lg-2 mt-2'>
                                        <button type="button" className='btn btn-success w-100' onClick={_ExportExcel}>
                                            <i className='fas fa-file-excel me-1'></i> Export Excel
                                        </button>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <p className='text-muted'>
                                            Export ข้อมูลตั้งแต่เดือน <strong>{toThai(_StartDate)}</strong> ถึงเดือน <strong>{toThai(_EndDate)}</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default React.memo(PageMonthExport);
